import { render } from "./ListGroupItem.vue?vue&type=template&id=659a622f"
import script from "./ListGroupItem.vue?vue&type=script&lang=js"
export * from "./ListGroupItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/ListGroupItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "659a622f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('659a622f', __exports__)) {
    api.reload('659a622f', __exports__)
  }
  
  module.hot.accept("./ListGroupItem.vue?vue&type=template&id=659a622f", () => {
    api.rerender('659a622f', render)
  })

}


export default __exports__